// extracted by mini-css-extract-plugin
module.exports = {"singleInput":"otp_singleInput__OSyuL"};